<div  @fadeInOut [class]="viewType === 'TABLE_LOADING' ? 'TABLE_LOADING' : 'REGULAR_LOADING'">
	<div class="preloader-demo">
		<div class="preloader-6"></div>
		<div class="loadingtext">...{{verbiage}}...</div>
	</div>
</div>